import * as actions from '../actions/plane-operators';
import * as models from '../../models';

import { createReducer, on } from '@ngrx/store';

export interface State {
  loaded: boolean;
  loading: boolean;
  planeOperators: Array<models.PlaneOperator>;
}

const initialState: State = {
  loaded: false,
  loading: false,
  planeOperators: [],
};

export const reducer = createReducer(
  initialState,
  on(
    actions.load,
    (state): State => ({
      ...state,
      loading: true,
    })
  ),

  on(
    actions.loadSuccess,
    (state, { payload: { planeOperators } }): State => ({
      ...state,
      loaded: true,
      loading: false,
      planeOperators,
    })
  ),

  on(
    actions.loadFailed,
    (state): State => ({
      ...state,
      loaded: true,
      loading: false,
    })
  )
);
